import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';
import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
  ApexDataLabels,
} from 'ng-apexcharts';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { StaffService } from '../../_services/staff.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { GlobalService } from '../../_services/global.service';
import { DepartmentService } from '../../_services/department.service';
import {
  DashboardFilter,
  InitialDashboardFilter,
  TimelineType,
} from '../../interfaces/dashboard.interface';
import { finalize, debounceTime } from 'rxjs/operators';
import { Staff } from '../../_models/mentorship';
import { Filter } from 'libs/shared/ui/components/src/lib/filter/filter.interface';
import { AuthService } from '../../_services/auth.service';
export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  colors: string[];
  dataLabels: ApexDataLabels;
};

@Component({
  selector: 'iq-central-front-end-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  pastDue;
  complianceLevel;
  edit: boolean;
  departments: any[] = [];
  dashboardDeets: any;
  weeklyGoal: FormGroup;
  goal: any;
  sub: Subscription = new Subscription();
  selectedItems: any[] = [];
  filterQuery: DashboardFilter = { ...InitialDashboardFilter };
  isFetchingUsers: boolean = false;
  isFetchingDepartments: boolean = false;
  isFetchingDashboard: boolean = false;
  searchTerm: string = '';

  myControl = new FormControl('');
  totalStaffs: Staff[];
  paginationInfo: {
    number: number;
    size: number;
    totalElements: number;
    totalPages: number;
  };
  filteredStaffs: Observable<Staff[]>;
  user: any;

  @ViewChild('chart') chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly fb: FormBuilder,
    private readonly _global: GlobalService,
    private readonly _staffService: StaffService,
    private readonly _department: DepartmentService,
    private readonly authService: AuthService
  ) {
    this.user = this.authService.getLoggedInUser();

    this.chartOptions = {
      series: [],
      chart: {
        type: 'donut',
      },
      labels: ['Assigned Courses', 'Learning Path', 'Enrolled Courses'],
      colors: ['#EA5E5E', '#FFC061', '#1CB4AE'],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 300,
            },
            legend: {
              show: false,
              position: 'bottom',
            },
          },
        },
      ],
      dataLabels: {
        enabled: false,
      },
    };
  }

  ngOnInit(): void {
    this.getDashboard();
    this.getDepartments();
    this.getAllStaffs();
    this.initWeeklyGoal();
    this.setupSearch();
  }

  displayFn(staff: Staff): string {
    return staff && staff.user && staff.user.fullName
      ? staff.user.fullName
      : '';
  }

  private setupSearch() {
    this.sub.add(
      this.myControl.valueChanges.pipe(debounceTime(300)).subscribe((value) => {
        const searchTerm =
          typeof value === 'string' ? value : value?.user?.fullName || '';
        this.searchTerm = searchTerm;

        this.getAllStaffs();
      })
    );
  }

  getDepartments() {
    this.isFetchingDepartments = true;

    this.sub.add(
      this._department
        .getAllDepartments(this.filterQuery)
        .pipe(finalize(() => (this.isFetchingDepartments = false)))
        .subscribe((res) => {
          this.departments = res['responseResult'];
        })
    );
  }

  getDashboard() {
    this.isFetchingDashboard = false;

    this.sub.add(
      this._staffService
        .getDashboardContents(this.filterQuery)
        .pipe(finalize(() => (this.isFetchingDashboard = false)))
        .subscribe((res) => {
          this.dashboardDeets = res['responseResult'];
          this.goal = this.dashboardDeets['weeklyGoal'];

          this.updateSeries();
        })
    );
  }

  public updateSeries() {
    this.chartOptions.series = [
      this.dashboardDeets?.totalAssignedCourses,
      this.dashboardDeets?.totalAssignedLearningPaths,
      this.dashboardDeets?.totalEnrolledCourses,
    ];
  }

  getAllStaffs() {
    this.isFetchingUsers = true;

    this.sub.add(
      this._staffService
        .getAllEnterpriseUsers(1, 999, this.searchTerm)
        .pipe(finalize(() => (this.isFetchingUsers = false)))
        .subscribe({
          next: (res) => {
            const result = res['responseResult'];
            this.paginationInfo = result['paginationInfo'];

            const staffs = result['users'];

            if (this.filterQuery?.departmentId) {
              console.log(this.filterQuery?.departmentId, staffs);
              this.totalStaffs = staffs.filter(
                (staff) =>
                  staff?.department?.id === this.filterQuery.departmentId
              );
            } else {
              this.totalStaffs = staffs;
            }

            if (this.searchTerm === '') {
              this.filterQuery = {
                ...this.filterQuery,
                userId: null,
              };
              this.getDashboard();
              this.getDepartments();
            }
          },
        })
    );
  }

  onStaffSelected(event: any) {
    const selectedStaff: Staff = event.option.value;

    this.filterQuery = {
      ...this.filterQuery,
      userId: selectedStaff.id,
    };

    this.getDashboard();
    this.getDepartments();
  }

  toggleEdit() {
    let x = document.getElementById('edit_button').innerText;
    if (x === 'EDIT') {
      document.getElementById('edit_button').innerText = 'BACK';
    } else {
      document.getElementById('edit_button').innerText = 'EDIT';
    }

    this.edit = !this.edit;
  }

  initWeeklyGoal() {
    this.weeklyGoal = this.fb.group({
      goal: [1, [Validators.required]],
    });
  }

  onSubmit() {
    this._global.showSpinner();
    const payload = this.weeklyGoal.value;
    this.sub.add(
      this._staffService.setWeeklyGoal(payload).subscribe({
        next: (response) => {
          this._global.successHandlerWithObject(response);
          this.goal = response['responseResult'].goal;
        },
      })
    );
  }

  goToChoosenRoute(route) {
    this.router.navigate([route]);
  }

  filterDashboard(filter: Filter) {
    this.filterQuery = {
      ...this.filterQuery,
      departmentId: filter.user.value,
      timelineType: filter.created.value ?? TimelineType.AllTime,
    };

    this.getAllStaffs();
    this.getDashboard();
    this.getDepartments();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
